import React, { Component } from 'react';
import {
    Route,
    Switch
} from 'react-router-dom';
import AuthContainer from '../Auth/AuthContainer';
import UpdatePassword from '../UpdatePassword/UpdatePassword';
import Layout from '../Layout/Layout';
import SearchBody from '../Search/Body/Body';
import Dashboard from '../Dashboard/Dashboard';
import ErrorCard from '../ErrorCard/ErrorCard';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Transactions from '../Transactions/Transactions';
import Transaction from '../Transaction/Transaction';
import DepositSummary from '../DepositSummary/DepositSummary';
import Chargebacks from '../Chargebacks/Chargebacks';
import Chargeback from '../Chargeback/Chargeback';
import Statements from '../Statements/Statements';
import Adjustments from '../Adjustments/Adjustments';
import Batches from '../Batches/Batches';
import Support from '../Support/Support';
import Fraud from '../Fraud/Fraud';
import Reserves from '../Reserves/Reserves';
import Exports from '../Exports/Exports';
import Settings from '../Settings/Settings';
import UserSetup from '../UserSetup/UserSetup';
import Signup from '../Signup/Signup';
import ReadmeLogin from '../Login/ReadmeLogin';
import VirtualTerminal from '../VirtualTerminal/VirtualTerminal';
import WebhookLogEntry from '../WebhookLog/WebhookLogEntry';
import NexioAgreement from '../AccountAgreement/NexioAgreement/NexioAgreement';
import UserRoutingRules from '../PaymentRouting/UserRoutingRules/UserRoutingRules';
import Payouts from '../Payouts/Payouts';
import PayoutRecipients from '../PayoutRecipients/PayoutRecipients';
import Payout from '../Payout/Payout';
import Spendbacks from '../Spendbacks/Spendbacks';
import Spendback from '../Spendback/Spendback';
import PayoutBatches from '../PayoutBatches/PayoutBatches';
import PendingPayouts from '../PendingPayouts/PendingPayouts';
import PendingPayoutBatches from '../PendingPayoutBatches/PendingPayoutBatches';
import PayoutBatch from '../PayoutBatch/PayoutBatch';
import ErroredPayouts from '../Payouts/ErroredPayouts/ErroredPayouts';
import ResellerDashboard from '../ResellerDashboard/ResellerDashboard';
import Residuals from '../Residuals/Residuals';
import ProcessorOnboarding from '../ProcessorOnboarding/ProcessorOnboarding';
import AgentResiduals from '../AgentResiduals/AgentResiduals';
import LeadToLive from '../LeadToLive/LeadToLive';
import PrevetForm from '../MerchantDetailsPage/PrevetForm/PrevetForm';
import MerchantDetailsPage from '../MerchantDetailsPage/MerchantDetailsPage';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    getAccountType,
    getCustomAccess,
    getIsSuccessful,
    getRole
} from '../Self/selfEntity';
import config from '../../config/config';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import { historyShape } from '../../utils/propTypes';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { getAccountName, getIsLoggedIn } from '../UserData/userDataEntity';
import PayoutRecipient from '../PayoutRecipient/PayoutRecipient';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

const searchResultsRenderer = () => makeViewRoute(<SearchBody />, {
    isSearchOpen: true,
    shouldRemoveBodyMargins: true,
    routesList
});

const makeViewRoute = (children, props) => (
    <AuthContainer>
        <Layout {...props}>
            {children}
        </Layout>
    </AuthContainer>
);

const arns = config.serviceArns;
export const routesList = {
    home: {
        requiredAccountType: 'RESELLER',
        route: '/home',
        title: 'PORTFOLIO OVERVIEW',
        component: ResellerDashboard,
        launchDarklyFlag: 'resellerPhase1',
        restrictedAccess: {
            [arns.transaction]: ['GET/v3/reseller/transactionsSummary', 'GET/v3/reseller/getMerchantTransactionSummary'],
            [arns.chargeback]: ['GET/v3/getMonthlyChargebackCount']
        }
    },
    homeLegacy: {
        requiredAccountType: 'RESELLER',
        route: '/home',
        title: 'OVERVIEW',
        component: ResellerDashboard,
        restrictedAccess: {
            [arns.transaction]: ['GET/v3/reseller/transactionsSummary', 'GET/v3/reseller/getMerchantTransactionSummary'],
            [arns.chargeback]: ['GET/v3/getMonthlyChargebackCount']
        }
    },
    processorOnboardingStatus: {
        requiredAccountType: 'RESELLER',
        route: '/boardingStatus',
        title: 'BOARDING STATUS',
        component: ProcessorOnboarding
    },
    residuals: {
        requiredAccountType: 'RESELLER',
        route: '/residuals',
        title: 'RESIDUALS',
        component: Residuals,
        restrictedAccess: {
            [arns.residual]: ['GET/v3/reseller/agent', 'GET/v3/reseller/agent/{agentId}']
        },
        accessRequiresAllUrls: true
    },
    residual: {
        requiredAccountType: 'RESELLER',
        route: '/residuals/agent/:id',
        fallback: {
            title: 'RESIDUALS',
            url: '/residuals'
        },
        matcher: /\/residuals\/agent\/-?\d+/,
        title: 'AGENT RESIDUALS',
        component: AgentResiduals,
        restrictedAccess: {
            [arns.residual]: ['GET/v3/reseller/agent', 'GET/v3/reseller/agent/{agentId}']
        },
        accessRequiresAllUrls: true
    },
    pathToLive: {
        requiredAccountType: 'RESELLER',
        route: '/pathToLive',
        title: 'PATH TO LIVE',
        component: LeadToLive,
        launchDarklyFlag: 'resellerPhase1'
    },
    merchantDetailsPage: {
        requiredAccountType: 'RESELLER',
        route: '/merchantdetails/:onboardingId',
        fallback: {
            title: 'PATH TO LIVE',
            url: '/pathToLive'
        },
        matcher: /\/merchantdetails\/\d+/,
        title: 'MERCHANT DETAIL PAGE',
        component: MerchantDetailsPage,
        launchDarklyFlag: 'resellerPhase1'
    },
    prevetForm: {
        requiredAccountType: 'RESELLER',
        route: '/prevet',
        title: 'PRE-VET',
        component: PrevetForm,
        launchDarklyFlag: 'resellerPhase1'
    },
    dashboard: {
        route: '/dashboard',
        title: 'MERCHANT DASHBOARD',
        component: Dashboard,
        restrictedAccess: {
            [arns.transaction]: ['GET/v3/transactionsSummary', 'GET/v3/getMerchantTransactionSummary'],
            [arns.chargeback]: ['GET/v3/getMonthlyChargebackCount']
        }
    },
    virtualTerminal: {
        route: '/virtualTerminal',
        title: 'VIRTUAL TERMINAL',
        component: VirtualTerminal,
        restrictedAccess: {
            [arns.pay]: [
                'GET/v3/merchant',
                'GET/v3/getTerminalList',
                'GET/v3/processFromTerminal/{terminalRequestId}',
                'GET/v3/echeck',
                'GET/v3/vault/card/{tokenexToken}',
                'POST/v3/processECheck',
                'POST/v3/saveEcheckAuthed',
                'POST/pay/v3/getTokenexIframeToken',
                'POST/v3/process',
                'POST/v3/saveCardAuthed',
                'POST/v3/pairTerminal',
                'POST/v3/processFromTerminal'
            ]
        },
        accessRequiresAllUrls: true
    },
    transactions: {
        route: '/transaction',
        title: 'TRANSACTIONS',
        component: Transactions,
        restrictedAccess: {
            [arns.transaction]: ['GET/v3']
        }
    },
    transaction: {
        route: '/transaction/:id',
        fallback: {
            title: 'TRANSACTIONS',
            url: '/transaction'
        },
        matcher: /\/transaction\/\d+/,
        title: 'TRANSACTION',
        component: Transaction
    },
    payouts: {
        route: '/payout',
        title: 'PAYOUTS',
        component: Payouts,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    payout: {
        route: '/payout/:id',
        fallback: {
            title: 'PAYOUTS',
            url: '/payout'
        },
        matcher: /\/payout\/\d+/,
        title: 'PAYOUT',
        component: Payout,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    payoutRecipients: {
        route: '/payout-recipient',
        title: 'RECIPIENTS',
        component: PayoutRecipients,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        },
        matcher: /\/payout-recipient$/
    },
    payoutRecipient: {
        route: '/payout-recipient/:id',
        fallback: {
            title: 'RECIPIENTS',
            url: '/payout-recipient'
        },
        matcher: /\/payout-recipient\/\d+/,
        title: 'RECIPIENT',
        component: PayoutRecipient,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    spendbacks: {
        route: '/spendback',
        title: 'SPENDBACKS',
        component: Spendbacks,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    spendback: {
        route: '/spendback/:id',
        fallback: {
            title: 'SPENDBACKS',
            url: '/spendback'
        },
        matcher: /\/spendback\/\d+/,
        title: 'SPENDBACK',
        component: Spendback,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    payoutBatches: {
        route: '/payout-batch',
        title: 'PAYOUT BATCHES',
        matcher: /\/payout-batch$/,
        component: PayoutBatches,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    payoutBatch: {
        route: '/payout-batch/:id',
        title: 'PAYOUT BATCH',
        matcher: /\/payout-batch\/\d+/,
        fallback: {
            title: 'PAYOUT BATCHES',
            url: '/payout-batch'
        },
        component: PayoutBatch,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    erroredPayouts: {
        route: '/errored-payout',
        title: 'ERRORED PAYOUTS',
        component: ErroredPayouts,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    pendingPayoutBatches: {
        route: '/pending-payout-batch',
        title: 'PENDING PAYOUT BATCHES',
        component: PendingPayoutBatches,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    pendingPayoutBatch: {
        route: '/pending-payout/:batchRef/:providerId/:currency',
        matcher: /\/pending-payout\/.+/,
        fallback: {
            title: 'PENDING PAYOUTS',
            url: '/payout-batch'
        },
        title: 'PENDING PAYOUTS',
        component: PendingPayouts,
        restrictedAccess: {
            [arns.payout]: ['GET/v3']
        }
    },
    depositSummary: {
        route: '/reports/deposit-summary',
        title: 'DEPOSIT SUMMARIES',
        component: DepositSummary,
        restrictedAccess: {
            [arns.ach]: ['GET/v3']
        }
    },
    chargebacks: {
        route: '/chargeback',
        title: 'CHARGEBACKS',
        component: Chargebacks,
        restrictedAccess: {
            [arns.chargeback]: ['GET/v3/summary', 'GET/v3']
        }
    },
    chargeback: {
        route: '/chargeback/:id',
        component: Chargeback,
        matcher: /\/chargeback\/\d+/,
        fallback: {
            title: 'CHARGEBACKS',
            url: '/chargeback'
        },
        title: 'CHARGEBACK'
    },
    adjustments: {
        route: '/reports/adjustments',
        title: 'ADJUSTMENTS',
        component: Adjustments,
        restrictedAccess: {
            [arns.report]: ['GET/v3/adjustments']
        }
    },
    batchDetails: {
        route: '/reports/batch-details',
        title: 'BATCH DETAILS',
        component: Batches,
        restrictedAccess: {
            [arns.batch]: ['GET/v3/batches']
        }
    },
    statements: {
        route: '/reports/statements',
        title: 'STATEMENTS',
        component: Statements,
        restrictedAccess: {
            [arns.report]: ['GET/v3/statements']
        }
    },
    fraud: {
        route: '/reports/fraud',
        title: 'FRAUD',
        component: Fraud,
        restrictedAccess: {
            [arns.transaction]: ['GET/v3', 'GET/v3/count']
        },
        accessRequiresAllUrls: true
    },
    reserves: {
        route: '/reports/reserves',
        title: 'RESERVES',
        component: Reserves,
        restrictedAccess: {
            [arns.reserve]: ['GET/v3']
        }
    },
    exports: {
        route: '/exports',
        title: 'EXPORTS',
        component: Exports,
        restrictedAccess: {
            [arns.exports]: ['GET/v3/getExports']
        }
    },
    settings: {
        route: '/settings',
        title: 'SETTINGS',
        component: Settings
    },
    settingsNotifications: {
        route: '/settings/notifications',
        title: 'SETTINGS',
        component: Settings
    },
    settingsDetails: {
        route: '/settings/details',
        title: 'SETTINGS',
        component: Settings
    },
    settingsUserManagement: {
        route: '/settings/userManagement',
        title: 'SETTINGS',
        component: Settings
    },
    settingsRouteManagement: {
        route: '/settings/routeManagement',
        title: 'SETTINGS',
        component: Settings
    },
    settingsMerchantManagement: {
        route: '/settings/merchantManagement',
        title: 'SETTINGS',
        component: Settings
    },
    settingsWebhookLog: {
        route: '/settings/webhookLog',
        title: 'SETTINGS',
        component: Settings
    },
    webhook: {
        route: '/webhook/:logId',
        matcher: /\/webhook\/\d+/,
        fallback: {
            title: 'WEBHOOKS',
            url: '/settings/webhookLog'
        },
        title: 'WEBHOOK',
        component: WebhookLogEntry
    },
    routingRules: {
        route: '/routingRules/:encodedUserName',
        matcher: /\/routingRules\/[a-zA-Z=]+/,
        fallback: {
            title: 'PAYMENT ROUTING',
            url: '/settings/routeManagement'
        },
        title: 'PAYMENT ROUTING RULES',
        component: UserRoutingRules
    },
    support: {
        route: '/support',
        component: Support,
        fallback: {
            title: 'DASHBOARD',
            url: '/support'
        },
        title: 'SUPPORT',
        restrictedAccess: {
            [arns.email]: ['POST/v3/support']
        }
    },
    searchQuery: {
        route: '/search/:filter/:query',
        matcher: /\/search\/.+/,
        fallback: {
            title: 'MERCHANT DASHBOARD',
            url: '/dashboard'
        },
        title: 'SEARCH',
        customRender: searchResultsRenderer
    },
    searchFilter: {
        route: '/search/:filter',
        matcher: /\/search\/.+/,
        customRender: searchResultsRenderer
    },
    updatePassword: {
        route: '/updatePassword/:verificationCode',
        matcher: /\/updatePassword\/.+/,
        component: UpdatePassword,
        authRequired: false
    },
    setFirstPassword: {
        route: '/setFirstPassword',
        customRender: () => <UpdatePassword isFirstLogin />,
        authRequired: false
    },
    userSetup: {
        route: '/userSetup',
        customRender: () => <AuthContainer><UserSetup /><NexioAgreement /></AuthContainer>
    },
    signup: {
        route: '/signup',
        component: Signup,
        authRequired: false
    }
};
const env = process.env.BUILD_ENV;

// we are adding this route for readme docs login only for dev and sandbox
if (env === 'sandbox' || env === 'development') {
    _.set(routesList, 'readmeLogin', {
        route: '/readme-login',
        component: ReadmeLogin,
        authRequired: false
    });
}

export let nonChildRoutes = [];
_.map(routesList, (route) => {
    if (!_.includes(route.route, ':')) {
        nonChildRoutes.push(route.route);
    }
});

export function buildLocationInfoByUrl(routes) {
    let locationInfoByUrl = {};
    _.map(routes, (routeInfo) => {
        if (routeInfo.title) {
            const colonIndex = _.indexOf(routeInfo.route, ':');
            const locationKey = colonIndex === -1 ? routeInfo.route :
                _.join(_.slice(routeInfo.route, 0, colonIndex), '');

            locationInfoByUrl[locationKey] = { title: routeInfo.title };

            if (routeInfo.fallback) {
                locationInfoByUrl[locationKey].fallback = routeInfo.fallback;
            }

            if (routeInfo.matcher) {
                locationInfoByUrl[locationKey].matcher = routeInfo.matcher;
            }
        }
    });

    return locationInfoByUrl;
}

export const locationInfoByUrl = buildLocationInfoByUrl(routesList);

export class Routes extends Component {
    static propTypes = {
        accountName: PropTypes.string,
        customAccess: PropTypes.any,
        accountType: PropTypes.string,
        isLoggedIn: PropTypes.bool,
        isSelfSuccessful: PropTypes.bool,
        history: historyShape,
        flags: PropTypes.object
    };

    decideRoute = () => {
        const validRoutes = [];
        const startPathName = _.get(this.props.history, 'location.pathname');
        const currentRoute = _.find(routesList, (route) => {
            if (route.matcher) {
                return route.matcher.test(startPathName);
            } else {
                return _.isEqual(route.route, startPathName);
            }
        });
        if (currentRoute && currentRoute.launchDarklyFlag) {
            const flags = this.props.flags;
            const hasFlagKey = !!(flags && Object.prototype.hasOwnProperty.call(flags, currentRoute.launchDarklyFlag));
            if (!hasFlagKey) {
                return;
            }
        }
        _.map(routesList, (route) => {

            if (route.canAccess !== false) {
                if (route.requiredAccountType) {
                    if (route.requiredAccountType === this.props.accountType) {
                        validRoutes.push(route);
                    }
                } else {
                    validRoutes.push(route);
                }
            }
        });

        const firstValidRoute = validRoutes[0];

        const pathName = _.get(this.props.history, 'location.pathname');
        if (firstValidRoute && this.props.isLoggedIn) {
            const doesPathMatchARoute = _.some(validRoutes, (validRoute) => {
                if (validRoute.matcher) {
                    return validRoute.matcher.test(pathName);
                } else {
                    return _.isEqual(validRoute.route, pathName);
                }
            });

            if (!doesPathMatchARoute) {
                this.props.history.push(firstValidRoute.route);
            }
        }
    };

    doesUserHaveAccessToFeature = (route) => {
        const customAccess = this.props.customAccess;
        const { restrictedAccess, accessRequiresAllUrls, launchDarklyFlag } = route;
        const flags = this.props.flags;

        let userHasAccess = true;
        if (route.restrictedAccess && customAccess) {
            userHasAccess = doesRoleHaveAccessToFeature(customAccess, restrictedAccess, accessRequiresAllUrls);
        }

        if (launchDarklyFlag) {
            if (flags && Object.prototype.hasOwnProperty.call(flags, launchDarklyFlag)) {
                if (!flags[launchDarklyFlag]) {
                    userHasAccess = false;
                }
            }
        }

        return userHasAccess;
    };

    componentDidUpdate(prevProps) {
        const prevPathname = _.get(prevProps.history, 'location.pathname');
        const currentPathname = _.get(this.props.history, 'location.pathname');
        const pathnameChanged = prevPathname !== currentPathname;

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSelfSuccessful')) {
            if (this.initialRouteDecideTimer) {
                clearTimeout(this.initialRouteDecideTimer);
            }
            this.initialRouteDecideTimer = setTimeout(() => {
                this.decideRoute();
                this.initialRouteDecideTimer = null;
            }, 100);
        } else if (pathnameChanged && this.props.isLoggedIn) {
            if (this.routeDecideTimer) {
                clearTimeout(this.routeDecideTimer);
            }
            this.routeDecideTimer = setTimeout(() => {
                this.decideRoute();
                this.routeDecideTimer = null;
            }, 100);
        }
    }

    componentWillUnmount() {
        if (this.initialRouteDecideTimer) {
            clearTimeout(this.initialRouteDecideTimer);
            this.initialRouteDecideTimer = null;
        }
        if (this.routeDecideTimer) {
            clearTimeout(this.routeDecideTimer);
            this.routeDecideTimer = null;
        }
    }

    getRouteComponents = (routesList) => {
        return _.reduce(routesList, (acc, route) => {
            let render;
            if (route.customRender) {
                render = route.customRender;
            } else if (route.component) {
                if (route.authRequired === false) {
                    render = () => <route.component />;
                } else {
                    render = () => makeViewRoute(<route.component />, { routesList });
                }
            }

            acc.push(<Route
                key={route.route}
                exact
                path={route.route}
                render={render}
            />);

            return acc;
        }, []);
    };

    render() {
        const routeComponents = this.getRouteComponents(routesList);
        if (this.props.isSelfSuccessful || this.props.accountName) {
            _.forEach(routesList, (route) => {
                const hasFeatureAccess = this.doesUserHaveAccessToFeature(route);
                if (route.launchDarklyFlag) {
                    route.canAccess = hasFeatureAccess;
                } else {
                    route.canAccess = hasFeatureAccess || !!this.props.accountName;
                }
            });
        }

        return (
            <Switch>
                {routeComponents}
                <Route render={() => makeViewRoute(<ErrorCard />, { isErrorPage: true, routesList })} />
            </Switch>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountName: getAccountName(state),
        accountType: getAccountType(state),
        isLoggedIn: getIsLoggedIn(state),
        customRole: getRole(state),
        isSelfSuccessful: getIsSuccessful(state),
        customAccess: getCustomAccess(state)
    };
}

function mapDispatchToProps() {
    return {};
}

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Routes)));
